// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3myWh","footer":"styles_footer__1GDhS","passCodeTooltip":"styles_passCodeTooltip__3YCTn"};